import React, { useState, useEffect } from "react";
import { Box, Button, Chip, Divider, Typography } from "@mui/material";
import AvailableBatches from "./subTable/AvailableBatches";
import AllClusters from "./subTable/AllClusters";
import Completed from "./subTable/Completed";
import Accepted from "./subTable/Accepted";
import Incomplete from "./subTable/Incomplete";
import NotAccepted from "./subTable/NotAccepted";
import { Snackbar, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import AvailableJobs from "./subTable/AvailableJobs";
import ModalToCreateJobBatches from "../ModalToCreateJobBatches";
import axios from "axios";
import GlobalSnackbar from "../../../../shared/utils/GlobalSnackbar";
import AddJobDialog from "../recce/addJobModal.jsx";
import { useParams } from "react-router-dom";

const ManufactureAllTabs = ({
  isDisabled,
  campaignData,
  setOpenModalToCreateJobClusters,
  setOpenModalToPublishJobClusters,
  openModalToCreateClustersForPrinting,
  setOpenModalToCreateClustersForPrinting,
  openModalToCreateJobClusters,
  service,
}) => {
  const filters = [
    "Available Jobs",
    "Available Batches",
    "All Clusters",
    "Incomplete",
    "Not Accepted",
    "Accepted",
    "Completed",
  ];
  // .filter(
  //   (filter) =>
  //     !(
  //       filter === "Available Jobs" &&
  //       campaignData?.scopeOfWork?.servicesNeeded?.includes("Recce")
  //     )
  // );
  const { id } = useParams();
  const [openModalToCreateJobBatches, setOpenModalToCreateJobBatches] =
    useState(false);
  const [availableJobs, setAvailableJobs] = useState([]);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [selectAllBatches, setSelectAllBatches] = useState(false);
  const [totalClusters, setTotalClusters] = useState(0);
  const [notAcceptClusterLength, setNotAcceptClusterLength] = useState(0);
  const [acceptedClusterLength, setAcceptedClusterLength] = useState(0);
  const [completedClusterLength, setCompletedClusterLength] = useState(0);
  const [incompleteClusterLength, setIncompleteClusterLength] = useState(0);
  const [openAddJob, setOpenAddJob] = useState(false);
  const [soDetails, setSoDetails] = React.useState([]);
  const [productDetails, setProductDetails] = React.useState([]);
  const [categoryData, setCategoryData] = useState([]);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const actions = [
    // "Create Clusters Manually",
    "Create Clusters Automatically",
    "Publish All Clusters",
    "Create Printing Clusters",
    "Create Batches",
  ];
  const chipStyles = {
    fontSize: "0.8rem",
    fontWeight: "400",
    padding: "6px 12px",
    backgroundColor: "transparent",
    border: "1px solid #d9dadb",
    color: "black",
  };

  const [selectedFilter, setSelectedFilter] = useState(
    // campaignData?.scopeOfWork?.servicesNeeded?.includes("Recce")
    //   ? "Available Batches"
    //   :
    "Available Jobs",
  );
  const [activeTable, setActiveTable] = useState(
    // campaignData?.scopeOfWork?.servicesNeeded?.includes("Recce")
    //   ? "Available Batches"
    //   :
    "Available Jobs",
  );
  const [availableBatches, setAvailableBatches] = useState([]);

  // Function to check if selected jobs have consistent product types
  const hasConsistentJobProductTypes = () => {
    if (selectedJobs.length === 0) return true;
    const firstProductType = selectedJobs[0]?.product?.productType;
    return selectedJobs.every(
      (job) => job?.product?.productType === firstProductType,
    );
  };

  // Function to get product type from a batch
  const getBatchProductType = (batch) => {
    // Try to get product type from the first job in the batch
    if (batch?.jobs && batch.jobs.length > 0) {
      return batch.jobs[0]?.product?.productType;
    }
  };

  // Function to check if selected batches have consistent product types
  const hasConsistentBatchProductTypes = () => {
    if (selectedBatches.length === 0) return true;
    const firstProductType = getBatchProductType(selectedBatches[0]);
    return selectedBatches.every(
      (batch) => getBatchProductType(batch) === firstProductType,
    );
  };

  // In ManufactureAllTabs component
  const isPaintingService = (batch) => {
    // Check if any job in the batch has painting service
    return batch?.jobs?.some((job) => {
      const productType = job?.product?.productType?.toLowerCase() || "";
      return productType.includes("painting") || productType.includes("paint");
    });
  };
  const handleFilterClick = (filter) => {
    setSelectedFilter(filter);
    setActiveTable(filter);
    if (filter !== "Available Jobs") {
      setSelectedJobs([]);
      setSelectAll(false);
    }
    if (filter !== "Available Batches") {
      setSelectedBatches([]);
      setSelectAllBatches(false);
    }
  };
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleActionClick = (action) => {
    if (action === "Publish All Clusters") {
      setOpenModalToPublishJobClusters(true);
    }
    if (action === "Create Clusters Automatically") {
      if (hasConsistentBatchProductTypes() && selectedBatches.length > 0) {
        setOpenModalToCreateJobClusters(true);
      }
    }
    if (action === "Create Printing Clusters") {
      if (hasConsistentBatchProductTypes() && selectedBatches.length > 0) {
        setOpenModalToCreateClustersForPrinting(true);
      }
    }
    if (action === "Create Batches") {
      if (hasConsistentJobProductTypes() && selectedJobs.length > 0) {
        setOpenModalToCreateJobBatches(true);
      }
    }
  };
  const updateJobInParent = (updatedJob) => {
    setAvailableJobs((prevJobs) =>
      prevJobs.map((job) => (job._id === updatedJob._id ? updatedJob : job)),
    );
  };

  const fetchAllJobsBasedOnCampaignId = async () => {
    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_URL
        }/manufacturingJobs/allAvailableJobsForManufacturing?campaignId=${
          campaignData?._id
        }&serviceType=${0}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response?.data?.success) {
        const allJobs = response.data.data;
        // setForBatch(allJobs);

        // const filteredJobs = allJobs.filter(
        //   (job) =>
        //     !job?.batchOfJobsForVendorId &&
        //     job?.jobApprovalStatus?.clientStatus === 1
        // );
        setSoDetails(response.data.soDetails);
        setProductDetails(response.data.productDetails);
        setCategoryData(response.data.categoryWithProducts || []);
        setAvailableJobs(allJobs); // render all jobs
      } else {
        console.error("API response not successful:", response?.data);
        setSnackbar({
          open: true,
          message: response?.data?.message || "Failed to fetch jobs",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error while fetching jobs", error);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Failed to fetch jobs",
        severity: "error",
      });
    }
  };

  const handleDataLength = (dataLength) => {
    setNotAcceptClusterLength(dataLength);
  };

  useEffect(() => {
    if (activeTable === "All Clusters") {
      // fetchClusterCount();
    }
  }, [activeTable, campaignData?._id]);

  useEffect(() => {
    if (
      campaignData?._id
      // &&
      // !campaignData?.scopeOfWork?.servicesNeeded?.includes("Recce")
    ) {
      console.log("Initializing job fetch...");
      fetchAllJobsBasedOnCampaignId();
    }
  }, [campaignData?._id, campaignData?.scopeOfWork?.servicesNeeded]);

  // Conditionally render actions based on the selected filter
  const filteredActions = actions.filter((action) => {
    if (
      selectedFilter === "Available Batches" &&
      action === "Publish All Clusters"
    ) {
      return false; // Remove "Publish All Clusters" for Available Batches
    }
    if (selectedFilter === "Available Batches" && action === "Create Batches") {
      return false; // Remove "Create Batches" for Available Batches
    }
    if (
      selectedFilter === "Not Accepted" &&
      action === "Create Clusters Automatically"
    ) {
      return false; // Remove "Create Clusters Automatically" for Not Accepted
    }
    if (selectedFilter === "Not Accepted" && action === "Create Batches") {
      return false; // Remove "Create Batches" for Not Accepted
    }
    if (
      selectedFilter === "All Clusters" &&
      action !== "Publish All Clusters"
    ) {
      return false; // Only show "Publish All Clusters" for All Clusters
    }
    if (selectedFilter === "Available Jobs" && action !== "Create Batches") {
      return false; // Only show "Create Batches" for Available Jobs
    }
    return true; // Include other actions as normal
  });

  return (
    <div>
      {/* Divider */}
      <Divider sx={{ marginBottom: "1rem" }} />

      {/* Filters and Actions Container */}
      <div className="flex flex-wrap justify-between items-center gap-4 ml-4 mr-[0rem] my-4">
        {/* Left Section: Filters */}
        <div
          className="filters-section"
          style={{ flex: 1, display: "flex", gap: "8px", flexWrap: "wrap" }}
        >
          {filters.map((filter) => (
            <Button
              variant="outlined"
              key={filter}
              sx={{
                fontSize: "0.8rem",
                textTransform: "none",
                borderRadius: "8px",
                padding: "4px 12px",
                color: selectedFilter === filter ? "white" : "black",
                borderColor:
                  selectedFilter === filter ? "transparent" : "#d9dadb",
                backgroundColor:
                  selectedFilter === filter ? "black" : "transparent",
                "&:hover": {
                  backgroundColor:
                    selectedFilter === filter ? "black" : "transparent",
                  borderColor:
                    selectedFilter === filter ? "transparent" : "#d9dadb",
                },
              }}
              onClick={() => handleFilterClick(filter)}
            >
              {filter}
            </Button>
          ))}
        </div>

        {/* Right Section: Actions */}
        <div
          className="actions-section"
          style={{
            flex: "0 1 auto",
            display: "flex",
            gap: "8px",
            justifyContent: "flex-end",
          }}
        >
          {/* Show cluster count chips for all tabs */}
          {selectedFilter === "Available Jobs" && (
            <Chip
              label={`Total Jobs Available: ${availableJobs.length}`}
              sx={chipStyles}
            />
          )}
          {selectedFilter === "All Clusters" && (
            <Chip label={`Total Clusters: ${totalClusters}`} sx={chipStyles} />
          )}
          {selectedFilter === "Not Accepted" && (
            <Chip
              label={`Total Clusters: ${notAcceptClusterLength}`}
              sx={chipStyles}
            />
          )}
          {selectedFilter === "Accepted" && (
            <Chip
              label={`Total Clusters: ${acceptedClusterLength}`}
              sx={chipStyles}
            />
          )}
          {selectedFilter === "Completed" && (
            <Chip
              label={`Total Clusters: ${completedClusterLength}`}
              sx={chipStyles}
            />
          )}
          {selectedFilter === "Incomplete" && (
            <Chip
              label={`Total Clusters: ${incompleteClusterLength}`}
              sx={chipStyles}
            />
          )}

          {selectedFilter === "Available Jobs" && productDetails.length > 0 && (
            <Button
              variant="outlined"
              sx={{
                fontSize: "0.8rem",
                textTransform: "none",
                borderRadius: "8px",
                padding: "4px 12px",
                color: "#418cff",
                borderColor: "#418cff",
                backgroundColor: "transparent",
              }}
              onClick={() => setOpenAddJob(true)}
            >
              Add Jobs
            </Button>
          )}

          {/* Show action buttons only for specific tabs */}
          {!["Completed", "Accepted", "Incomplete"].includes(
            selectedFilter,
          ) && (
            <>
              {filteredActions.map((action, index) => {
                const isCreateBatchesDisabled =
                  action === "Create Batches" &&
                  (availableJobs.length === 0 ||
                    selectedJobs.length === 0 ||
                    !hasConsistentJobProductTypes());

                const isCreateClustersDisabled =
                  action === "Create Clusters Automatically" &&
                  (availableBatches.length === 0 ||
                    selectedBatches.length === 0 ||
                    !hasConsistentBatchProductTypes());

                return (
                  <Button
                    key={action}
                    variant={index === 2 ? "contained" : "outlined"}
                    color={index === 2 ? "primary" : undefined}
                    disabled={
                      isDisabled === "recce" ||
                      isCreateBatchesDisabled ||
                      isCreateClustersDisabled ||
                      (action === "Create Batches Automatically" &&
                        selectedFilter === "All Clusters")
                    }
                    sx={{
                      fontSize: "0.8rem",
                      fontWeight: "400",
                      textTransform: "none",
                      borderRadius: "8px",
                      padding: "4px 12px",
                      color:
                        index === 0
                          ? "#418cff"
                          : index === 2
                            ? "white"
                            : "black",
                      borderColor: "#418cff",
                      backgroundColor:
                        isDisabled === "recce"
                          ? "black"
                          : index === 2
                            ? "primary.main"
                            : "transparent",
                      "&.Mui-disabled": {
                        backgroundColor: "#f5f5f5",
                        color: "rgba(0, 0, 0, 0.26)",
                        borderColor: "rgba(0, 0, 0, 0.12)",
                        cursor: "not-allowed",
                        pointerEvents: "auto",
                      },
                      "&:hover": {
                        backgroundColor:
                          isDisabled === "recce" ||
                          isCreateBatchesDisabled ||
                          isCreateClustersDisabled
                            ? "#f5f5f5"
                            : index === 2
                              ? "primary.dark"
                              : "rgba(66, 165, 245, 0.08)",
                      },
                    }}
                    onClick={() => handleActionClick(action)}
                  >
                    {action}
                  </Button>
                );
              })}
            </>
          )}
        </div>
      </div>

      {/* Warning message for inconsistent product types in jobs */}
      {selectedFilter === "Available Jobs" &&
        selectedJobs.length > 0 &&
        !hasConsistentJobProductTypes() && (
          <Box sx={{ mt: 1, mb: 1, mx: 2 }}>
            <Box
              sx={{
                p: 1.5,
                bgcolor: "#ffebee",
                borderRadius: 1,
                border: "1px solid #ffcdd2",
              }}
            >
              <Typography
                variant="body2"
                color="error"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <ErrorIcon fontSize="small" />
                <strong>Warning:</strong> Selected jobs have different product
                types. Please select jobs with the same product type to create a
                batch.
              </Typography>
            </Box>
          </Box>
        )}

      {/* Warning message for inconsistent product types in batches */}
      {selectedFilter === "Available Batches" &&
        selectedBatches.length > 0 &&
        !hasConsistentBatchProductTypes() && (
          <Box sx={{ mt: 1, mb: 1, mx: 2 }}>
            <Box
              sx={{
                p: 1.5,
                bgcolor: "#ffebee",
                borderRadius: 1,
                border: "1px solid #ffcdd2",
              }}
            >
              <Typography
                variant="body2"
                color="error"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <ErrorIcon fontSize="small" />
                <strong>Warning:</strong> Selected batches have different
                product types. Please select batches with the same product type
                to create clusters.
              </Typography>
            </Box>
          </Box>
        )}

      <Box sx={{ marginTop: "1rem" }}>
        {activeTable === "Available Jobs" && (
          <AvailableJobs
            updateJobInParent={updateJobInParent}
            availableJobs={availableJobs}
            selectedJobs={selectedJobs}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            setSelectedJobs={setSelectedJobs}
            setSnackbar={setSnackbar}
            service={service}
          />
        )}{" "}
        {activeTable === "Available Batches" && (
          <AvailableBatches
            setOpenModalToCreateJobClusters={setOpenModalToCreateJobClusters}
            openModalToCreateJobClusters={openModalToCreateJobClusters}
            campaignData={campaignData}
            availableBatches={availableBatches}
            setAvailableBatches={setAvailableBatches}
            setSelectAllBatches={setSelectAllBatches}
            selectAllBatches={selectAllBatches}
            selectedBatches={selectedBatches}
            setSelectedBatches={setSelectedBatches}
            soDetails={soDetails}
            productDetails={productDetails}
            categoryData={categoryData}
          />
        )}
        {activeTable === "All Clusters" && (
          <AllClusters setTotalClusters={setTotalClusters} />
        )}
        {activeTable === "Incomplete" && (
          <Incomplete
            onClusterChange={setIncompleteClusterLength}
            isPaintingService={isPaintingService}
            id={campaignData?._id}
          />
        )}
        {activeTable === "Not Accepted" && (
          <NotAccepted onClusterChange={handleDataLength} />
        )}
        {activeTable === "Accepted" && (
          <Accepted
            onClusterChange={setAcceptedClusterLength}
            isPaintingService={isPaintingService}
            id={campaignData?._id}
          />
        )}
        {activeTable === "Completed" && (
          <Completed
            onClusterChange={setCompletedClusterLength}
            isPaintingService={isPaintingService}
          />
        )}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={5000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }} // Positioned on the left side
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbar.severity}
            icon={
              snackbar.severity === "success" ? (
                <CheckCircleIcon sx={{ color: "white" }} />
              ) : (
                <ErrorIcon sx={{ color: "white" }} />
              )
            }
            sx={{
              backgroundColor:
                snackbar.severity === "success" ? "green" : "red",
              color: "white",
              display: "flex",
              alignItems: "center",
            }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
        {openModalToCreateJobBatches && (
          <ModalToCreateJobBatches
            // serviceTypeDynamic={serviceType}
            openModalToCreateJobBatches={openModalToCreateJobBatches}
            setOpenModalToCreateJobBatches={setOpenModalToCreateJobBatches}
            campaignData={campaignData._id}
            availableJobs={availableJobs}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            // serviceName={serviceName}
            setSnackbar={setSnackbar}
            setSelectedJobs={setSelectedJobs}
            selectedJobs={selectedJobs}
          />
        )}
        {openAddJob && (
          <AddJobDialog
            open={openAddJob}
            onClose={() => setOpenAddJob(false)}
            campaignId={id}
            soDetails={soDetails}
            productDetails={productDetails}
            categoryData={categoryData}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            // fetchAllBatchesBasedOnCampaignId={fetchAllBatchesBasedOnCampaignId}
            createJobFrom={"jobs"}
            jobForWhichService="Painting"
          />
        )}
        <GlobalSnackbar snackbar={snackbar} handleClose={handleSnackbarClose} />
      </Box>
    </div>
  );
};

export default ManufactureAllTabs;
